<template>
    <div>
        <v-container fluid class="py-0">
            <v-row v-if="loaded">
                <v-col>
                    <div class="owl-carousel-custom position-relative" style="overflow: hidden;">
                        <carousel :items="4" :autoplay="false" :nav="false" :dots="false" :responsive="{0:{items:2},600:{items:4}}">
                            <div>
                                <router-link to="/custom/category/all">
                                    <img src="@/assets/img/custom-all.jpg">
                                </router-link>
                            </div>
                            <div v-for="(category,c) in categories" :key="'custom-category-'+c" class="title-custom-category" v-bind:class="{'opac':overCategory != c && overCategory != -1, 'superOpac': route != 'aaa' && route != category.url}" @mouseover="overCategory = c;" @mouseleave="overCategory = -1;">
                                <router-link :to="'/custom/category/'+category.url">
                                    <img :src="'https://artlesscms.actstudio.xyz/'+category.cover.path">
                                </router-link>
                            </div>

                            <template slot="prev">
                                <span class="prev-icon"><v-icon size="36" color="#221F1F">mdi-chevron-left</v-icon></span>
                            </template>

                            <template slot="next">
                                <span class="next-icon"><v-icon size="36" color="#221F1F">mdi-chevron-right</v-icon></span>
                            </template>
                        </carousel>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <template v-if="url != '/custom/designers'">
                    <router-view v-bind:order="order" v-bind:orderXs="order_xs"></router-view>
                </template>
            </v-row>

            <v-row>
                <v-col cols="6" class="px-0 py-0" v-bind:class="{'opac':url == '/custom/designers'}">
                    <router-link to="/custom/about">
                        <v-img :src="'https://artlesscms.actstudio.xyz/'+custom.aboutImage.path"></v-img>
                    </router-link>
                </v-col>
                <v-col cols="6" class="px-0 py-0">
                    <router-link to="/custom/designers">
                        <v-img :src="'https://artlesscms.actstudio.xyz/'+custom.designerImage.path"></v-img>
                    </router-link>
                </v-col>
            </v-row>

            <div id="designers">
                <template v-if="url == '/custom/designers'">
                    <router-view v-bind:order="order"></router-view>
                </template>
            </div>

            <v-row v-if="instafeed.length > 0" class="my-0">
                <v-col class="pa-0">
                    
                    <div class="owl-carousel-custom" style="position: relative;">

                    <carousel :autoplay="false" :nav="false" :items="4" :dots="false" :responsive="{0:{items:1,margin:0},600:{items:4,margin:0}}" :loop="true">
                        <template v-for="(insta,i) in instafeed">
                        <a :href="insta.permalink" target="_blank" :key="'instagram-photo-'+i">
                            
                            <img :src="insta.media_url" class="instagram-feed-photo" />
                        </a>
                        </template>

                        <template slot="prev" class="ammm">
                            <span class="prev-icon"><v-icon size="36" color="#221F1F">mdi-chevron-left</v-icon></span>
                        </template>

                        <template slot="next" class="ammm">
                            <span class="next-icon"><v-icon size="36" color="#221F1F">mdi-chevron-right</v-icon></span>
                        </template>
                    </carousel>

                    </div>

                </v-col>
            </v-row>
        </v-container>
    </div>    
</template>

<script>
import goTo from 'vuetify/es5/services/goto'
import carousel from 'vue-owl-carousel'
export default {
    name: 'Custom',
    components: { carousel },
    data(){
        return {
            categories: [],
            order: 2,
            order_xs: 0,
            overCategory: -1,
            custom: {},
            loaded: false,
            instafeed: [],
            custom: {
                aboutImage: {
                    path: ''
                },
                designerImage: {
                    path: ''
                }
            }
        }
    },
    beforeMount: function () {
        var aux = this;
        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/CustomCategory?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                })
            }
        )
        .then(res => res.json())
        .then(res => (aux.categories = res.entries))
        .then(() => this.loaded = true)


        fetch('https://www.artlesscms.actstudio.xyz/api/singletons/get/Custom?token=a15be93e9cdb43ca2b3778c2077c26')
        .then(data => data.json())
        .then(data => this.custom = data);

        fetch('https://graph.instagram.com/me/media?fields=id,permalink,caption,media_url&access_token=IGQWRPUlZArRU1ENUgtSjhtUnZAlWXZA6REl3MmprdlpGR0FYd3M3Vmlkc1NKRDlDZAkVDZA0xRck5vbml1MDg4NUhja0NQSV9VWEsteUM3VENSZAWdkYUFvbE5mcnRhSTRLUDVaeEJ0NGxrRWk1UQZDZD')
        .then((data) => data.json())
        .then((data) => {
            this.instafeed = data.data
            if(this.instafeed == undefined){
                this.instafeed = [];
            }
        })

    },
    computed: {
        url: function(){
            return this.$route.path;
        },
        route: function(){
            if(this.$route.params.url == undefined){
                return 'aaa';
            }
            return this.$route.params.url;
        }
    },
    methods: {
        calcOrder: function(c){
            if(c%2 == 0){
                this.order = c + 2;
            }else{
                this.order = c + 1;
            }

            this.order_xs = c;
        }
    },
    watch: {
        $route(to, from) {
            if(to.fullPath == '/custom/designers'){
                goTo('#designers');
            }
        }
    },
    mounted() {
        var breadcrumbs = [
            // {
            //     text: 'Home',
            //     link: '/',
            //     isLink: true
            // },
            // {
            //     text: 'Custom',
            //     link: '/custom',
            //     isLink: false
            // }
        ];
        this.$emit("updateStatus", breadcrumbs);
        this.$emit("update", 2);
        gtag('config', 'UA-26953667-1', {
        'page_title' : 'Custom',
        'page_path': '/custom'
        });
    }
}
</script>